import { createAction, handleActions } from "redux-actions"
import { apiGet } from "../utils/apiConnector"
import {
  analyticsApi,
  getItemsWithText,
  productAnalyticsApi,
} from "../config/apiUrls"
import { endOfDay, startOfDay, subDays } from "date-fns"
import { combineReducers } from "redux"

// Default state
const defaultState = {
  isLoading: 0,
  saleAnalytics: {
    saleSum: 0,
    saleUniversalSum: 0,
    quantity: 0,
  },
  purchaseAnalytics: {
    sum: 0,
    quantity: 0,
  },
  profit: 0,
  items: [],
}

// Action Creators
/// setTodayLoading(flag)
const setTodayLoading = createAction("SET_TODAY_LOADING", (flag) =>
  flag ? 1 : -1,
)
/// setTodayAnalytics(data)
const setTodayAnalytics = createAction("SET_TODAY_ANALYTICS")
/// setYesterdayLoading(flag)
const setYesterdayLoading = createAction("SET_YESTERDAY_LOADING", (flag) =>
  flag ? 1 : -1,
)
/// setYesterdayAnalytics(data)
const setYesterdayAnalytics = createAction("SET_YESTERDAY_ANALYTICS")
const setItems = createAction("SET_ITEMS")
const nullAnalytics = createAction("NULL_ANALYTICS")

// Reducer
const today = handleActions(
  {
    [setTodayLoading]: (state, { payload }) => ({
      ...state,
      isLoading: state.isLoading + payload,
    }),
    [setTodayAnalytics]: (state, { payload }) => ({ ...state, ...payload }),
    [nullAnalytics]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
  defaultState,
)
const yesterday = handleActions(
  {
    [setYesterdayLoading]: (state, { payload }) => ({
      ...state,
      isLoading: state.isLoading + payload,
    }),
    [setYesterdayAnalytics]: (state, { payload }) => ({ ...state, ...payload }),
    [nullAnalytics]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
  defaultState,
)

const items = handleActions(
  {
    [setItems]: (state, { payload }) => ({
      ...state,
      items: [...payload],
    }),
  },
  defaultState,
)

const reducer = combineReducers({
  today,
  yesterday,
  items,
})
export default reducer

// Thunk
export function refreshTodayAnalytics() {
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    const today = new Date()
    dispatch(setTodayLoading(true))
    return apiGet(analyticsApi, {
      storeId,
      from: startOfDay(today),
      to: endOfDay(today),
    })
      .onOk((res) => {
        dispatch(setTodayAnalytics(res.data.response))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        dispatch(setTodayLoading(false))
      })
      .startSingle("today")
  }
}

export function refreshYesterdayAnalytics() {
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    const today = subDays(new Date(), 1)
    dispatch(setYesterdayLoading(true))
    return apiGet(analyticsApi, {
      storeId,
      from: startOfDay(today).toISOString(),
      to: endOfDay(today).toISOString(),
    })
      .onOk((res) => {
        dispatch(setYesterdayAnalytics(res.data.response))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        dispatch(setYesterdayLoading(false))
      })
      .startSingle("yesterday")
  }
}

export function refreshDailyAnalytics() {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(refreshTodayAnalytics())
    dispatch(refreshYesterdayAnalytics())
  }
}

export function getItems(value) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    apiGet(
      getItemsWithText + "q=" + value + "&storeId=" + storeId + "&limit=10",
    )
      .onOk((res) => {
        dispatch(setItems(res.data.response))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

export function refreshTodayProductAnalytics(stockId) {
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    const today = new Date()
    dispatch(setTodayLoading(true))
    return apiGet(productAnalyticsApi, {
      storeId,
      from: startOfDay(today),
      to: endOfDay(today),
      stockId,
    })
      .onOk((res) => {
        dispatch(setTodayAnalytics(res.data.response))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        dispatch(setTodayLoading(false))
      })
      .startSingle("today")
  }
}

export function refreshYesterdayProductAnalytics(stockId) {
  return (dispatch, getState) => {
    const storeId = getState().profile.currentStore.id
    const today = subDays(new Date(), 1)
    dispatch(setYesterdayLoading(true))
    return apiGet(productAnalyticsApi, {
      storeId,
      from: startOfDay(today).toISOString(),
      to: endOfDay(today).toISOString(),
      stockId,
    })
      .onOk((res) => {
        dispatch(setYesterdayAnalytics(res.data.response))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        dispatch(setYesterdayLoading(false))
      })
      .startSingle("yesterday")
  }
}

export function refreshDailyProductAnalytics(stockId) {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(refreshTodayProductAnalytics(stockId))
    dispatch(refreshYesterdayProductAnalytics(stockId))
  }
}

export function nullProductAnalytics() {
  // eslint-disable-next-line no-empty-pattern
  return (dispatch, {}) => {
    dispatch(nullAnalytics(defaultState))
  }
}
